import { object } from 'yup';

import { buildFields } from '../base/builders/buildValidationFields';

export default () => {
    const {
        name,
        parameters,
        parameters_commission_credit,
        parameters_hitch,
        parameters_rate,
    } = buildFields();

    return object().shape({
        name,
        parameters: object().shape({
            tax: parameters.tax,
            terms: parameters.terms,
        }),
        parameters_commission_credit,
        parameters_hitch,
        parameters_rate,
    });
};
